import { Link, useParams } from 'react-router-dom';
import numberWithCommas from '../utils/numberWithCommas';
import { Status } from '../../../../types/event';
import { formatTime } from '../../../../utils/get-event-start-time';
import { PATHNAMES } from "../../admin";

interface EventListElementProps {
	eventData: any
}

function EventListElement({ eventData }: EventListElementProps): JSX.Element {

	const { tab }: { tab?: string; } = useParams();

	const eventURL = eventData.uuid;
	const eventDate = eventData.start_time ? formatTime(eventData.start_time) : '';

	return (
		<Link to={`${PATHNAMES.AnalyticsLink}/${tab}/${eventURL}`} style={{ textDecoration: 'none' }}>
			<div className="events-list-element">
				<div>
					<p className="events-list-element-label">{eventDate}</p>
					<p className="events-list-element-value">{eventData.name}</p>
				</div>
				<div>
					<p className="events-list-element-label">Sessions</p>
					<p className="events-list-element-value">{numberWithCommas(parseInt(eventData.sessions.length))}</p>
				</div>
				<div>
					<p className="events-list-element-label">Registrations</p>
					<p className="events-list-element-value">{numberWithCommas(parseInt(eventData.registrations))}</p>
				</div>
				<div>
					<p className="events-list-element-label">Pageviews</p>
					<p className="events-list-element-value">{numberWithCommas(parseInt(eventData.pageviews))}</p>
				</div>
				<div>
					<p className="events-list-element-label status">Status</p>
					<p className={`events-list-element-value status ${Status[eventData.status]}`}>{Status[eventData.status]}</p>
				</div>
			</div>
		</Link>
	);
}

export default EventListElement;
